/* global __NAMESPACE__, ROOT_MOUNT_ID */
/* eslint-disable max-params */

import styles from '../shared/index.css'
import '../shared/stylesheets/byline.css'
import { visible } from '../shared/stylesheets/background.css'
import '../shared/stylesheets/alignment/index.css'
import videoStyles from '../shared/stylesheets/video.css'
import '../shared/stylesheets/animations.css'
import '../shared/stylesheets/block.css'
import { getMutedButton, getUnmutedButton } from '../shared/utils/muteButtons'
import { initialize as gaInitialize, trackAction } from '../shared/utils/googleAnalytics'
import { canAutoplay } from './utils/featuretests'
import { intersectionObserverCallback } from './intersection'
import { reduce } from './reducer'
import { components } from '../shared/components'

export default class App {
  constructor(container, initialState) {
    this.container = container
    this.error = null
    this.muted = true
    this.videoElements = []
    this.state = initialState

    this.gaInitialized = false
    this.sectionId = 0
    window.appParams = this
  }

  setSectionId = id => {
    this.sectionId = id
  }

  mount = () => {
    try {
      const sectionElements = [...document.querySelectorAll(`.${styles.section}`)]

      this.state.sections = this.state.sections.map((s, i) => {
        return {
          ...s,
          canAutoplay: this.state.canAutoplay,
          foregroundElement: sectionElements[i],
          backgroundElement: document.getElementById(s.id)
        }
      })

      this.shareButtons = document.querySelector(`.${styles.shareButtonGroup}`)
      const muteButton = document.querySelector(`.${videoStyles.videoMuteButton}`)
      if (muteButton) {
        this.muteButton = muteButton
        this.muteButton.addEventListener('click', this.toggleMuteVideo, false)
      }

      this.initializeGoogleAnalytic()
      this.mountListeners()
    } catch (error) {
      console.error(error)
      this.renderError()
    }
  }
  initializeGoogleAnalytic = () => {
    if (!this.gaInitialized) {
      gaInitialize(this.container.getAttribute('data-tracking'))
    }
    this.gaInitialized = true
  }

  unmount = () => {
    this.unmountListeners()
    this.container.innerHTML = ''
  }

  ioCallback = changes => intersectionObserverCallback(changes, this.state, this.dispatch)

  mountListeners = () => {
    const options = {
      threshold: [0]
    }

    this.observer = new IntersectionObserver(this.ioCallback, options)
    this.observer.POLL_INTERVAL = 500
    this.state.sections.forEach(({ foregroundElement }) =>
      this.observer.observe(foregroundElement)
    )

    const muteButton = document.querySelector(`.${videoStyles.videoMuteButton}`)
    if (muteButton) {
      this.muteButton = muteButton
      this.muteButton.addEventListener('click', this.toggleMuteVideo, false)
    }
  }

  render = () => {
    if (this.error) {
      this.renderError()
    }
  }

  renderError = () => {
    this.container.innerHTML = `<pre class="App--error">${this.error}</pre>`
  }
  toggleMuteVideo = e => {
    e.stopPropagation()

    this.dispatch({ type: 'toggleMute' })
    if (this.state.muted) {
      trackAction(`MUTE/${this.sectionId}`)
    } else {
      trackAction(`UNMUTE/${this.sectionId}`)
    }
  }
  dispatch = action => {
    this.state = reduce(this.state, action)
    this.onStateChanged(this.state)
  }

  onStateChanged = state => {
    if (state.showMuteButton) {
      this.muteButton.classList.add(visible)
    } else {
      this.muteButton.classList.remove(visible)
    }

    if (this.shareButtons && state.showShareButtons) {
      this.shareButtons.classList.add(visible)
    } else {
      this.shareButtons.classList.remove(visible)
    }

    if (state.muted) {
      this.muteButton.innerHTML = getMutedButton()
    } else {
      this.muteButton.innerHTML = getUnmutedButton()
    }

    components
      .filter(component => component.onStateChanged)
      .forEach(component => component.onStateChanged(state))
  }
}

window.App = App

if (module.hot) module.hot.accept()

const mountingNode = document.getElementById(ROOT_MOUNT_ID)
const initialState = JSON.parse(mountingNode.getAttribute('data-initial-state'))

const app = new App(mountingNode, initialState)
app.mount()

mountingNode.style.transition = '.5s .5s opacity ease-in'
mountingNode.style.opacity = 1



// WEBPACK FOOTER //
// ./src/client/index.js